<template>
	<div class="webContent flex">
		<div class="detail" @scroll="listenScroll">
			<div class="tool df hao jcb" v-if="pageType!='adminManager'">
				<div class="rule" v-if="isRule">公告</div>
				<div v-else></div>
				<div class="edit" @click="toEdit" v-if="status==2">修改问题</div>
				<div class="follow" :class="{ has: isFollow }" @click="follow" v-else>{{isFollow?'已关注':'关注问题'}}</div>
			</div>
			<div class="title">{{title}}</div>
			<div class="txt" v-html="txt">{{txt}}</div>
			<div class="file" v-if="files.length>0">
				<div class="fileLi df" v-for="(v, i) in files" :key="i">
					<div class="fileName flex">{{v.name}}</div>
					<!-- <a class="df wao hao" :href="v.url" target="_blank">下载</a> -->
					<a class="df wao hao" @click="downloadFile(v)">下载</a>
				</div>
			</div>
			<div class="end df hao">
				<div class="like" :class="{ has: isLike }" @click="like">{{likeCount}} 点赞</div>
				<div class="answer">{{answerCount}} 回答</div>
				<div class="flex"></div>
				<div class="user" @click="toUser(userId)">{{user}}（{{account}}）</div>
				<div class="date">{{date}}</div>
			</div>
			<div class="relation ov-d" v-if="relation.id!=''" @click="toDetail({ id: relation.id })">原始问题：{{relation.title}}</div>
			<div class="handle df hao" >
				<div class="answerBtn" :class="{ no: status==2 }" @click="toAnswer">写回答</div>
				<div class="flex df war hao" >
					<div class="topBtn" v-if="isMode" :class="{ has: type.indexOf('top')>=0 }" @click="openConfirm('top',title,type.indexOf('top')>=0)" >置顶</div>
					<div class="prizeBtn" v-if="isMode" :class="{ has: type.indexOf('prize')>=0 }" @click="openConfirm('prize',title,type.indexOf('prize')>=0)" >加精</div>
					<div class="removeBtn" v-if="isMode" @click="openConfirm('remove',title)">删除</div>
				</div>
			</div>
			<div class="list">
				<div class="li" :class="{ 'li-blue': v['creatorRoles'] === 'teacher' }" v-for="(v, i) in list" :key="i">
					<div class='best' v-if="v.bestFlag === 1">
						<img src="@/app/assets/best.png" style="width:0.16rem;height:0.16rem"/>
						<span class="bestTip">Best Answer 最佳答案</span>
					</div>
					<div class="li-tool df hao">
						<div class="li-user" @click="toUser(v.creatorId)">{{v.creatorName}}({{v.creatorMapperNumber}})</div>
						<div class="li-follow" :class="{ has: v.attention>0 }" @click="followItem(v.creatorId,v.attention,v)" v-if="$h5Userid!=v.creatorId">{{v.attention>0?'已关注':'关注'}}</div>
						<div class="flex"></div>

						<!-- <div class="li-addQuesition" v-if="$h5Power!='guest'" @click="aqItem">追加提问</div> -->
					</div>
					<div class="li-txt" v-html="v.content">{{v.content}}</div>
					<div class="li-file" v-if="v.files.length>0">
						<div class="li-fileLi df" v-for="(v2, i2) in v.files" :key="i2">
							<div class="li-fileName flex">{{v2.name}}</div>
							<!-- <a class="df wao hao" :href="v2.url" target="_blank">下载</a> -->
							<a class="df wao hao" @click="downloadFile(v2)">下载</a>
						</div>
					</div>
					<div class="li-end df hao jcb">
						<div class="li-date">{{dateTime(v.createTime)}}</div>
						<div style="display: flex;">
							<div class="li-like" :class="{ has: v.approval>0 }" @click="likeItem(v.id,v.approval,v)">{{v.approvalTotal}}</div>
							<div class="li-collect" :class="{ has: v.collection>0 }" @click="collectItem(v.id,v.collection,v)" style="margin-left: 105px;">{{v.collection>0?'已收藏':'收藏'}}</div>
						</div>
					</div>
					<div class="li-btn df war hao">
						<div v-if="(v.bestFlag !== 1 && isMode)" class="bestBtn" @click="setBestAnswer(v.id)">Best Answer</div>
						<!-- <div class="li-topBtn" v-if="isMode" :class="{ has: v.top==1 }" @click="openConfirm('topAns','',(v.top==1),v.id)">置顶</div> -->
						<!-- <div class="li-archiveBtn" v-if="isMode" @click="openConfirm('archive','','',v.id)">归档</div> -->
						<div class="li-removeBtn" v-if="isMode" @click="openConfirm('removeAns','','',v.id)">删除</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 收藏夹 -->
		<div class="collectBase" v-if="collectBase.has">
			<div class="collectBase-box">
				<div class="collectBase-top">
					<div class="collectBase-close" @click="closeCollectBase"></div>
					<span>已选择{{collectBase.choose.length}}个收藏夹</span>
					<div class="collectBase-add" @click="showCollectAddBase">新建收藏夹</div>
				</div>
				<div class="collectBase-list">
					<div class="collectBase-li df cf wao"
						:class="{ cur: collectBase.choose.indexOf(i)>=0 }"
						v-for="(v, i) in collectBase.list" :key="i"
						@click="chooseCollectBase(i)">
						<div class="collectBase-title">{{v.name}}</div>
						<div class="collectBase-answer">{{v.answerTotal}}个回答</div>
					</div>
				</div>
				<div class="collectBase-btn" @click="resCollectBase">确认</div>
			</div>
		</div>

		<!-- 添加收藏夹 -->
		<div class="collectAddBase df wao hao" v-if="collectAddBase.has">
			<div class="collectAddBase-box">
				<div class="collectAddBase-input df hao">
					<input type="text" puc class="flex" placeholder="输入收藏夹标题" v-model="collectAddBase.val" @input="checkInput" />
					<i>{{13-collectAddBase.val.length}}</i>
				</div>
				<div class="collectAddBase-end df war hao">
					<div class="collectAddBase-btn" @click="resCollectAddBase">确认</div>
					<div class="collectAddBase-btn" @click="closeCollectAddBase">取消</div>
				</div>
			</div>
		</div>

		<!-- 确认弹框 -->
		<div class="confirm df wao hao" v-if="confirm.has">
			<div class="confirm-box">
				<div class="confirm-txt df wao" v-if="confirm.type=='top'">确认对“<div class="ov-d" :class="{ flex: confirm.txt.length>6}">{{confirm.txt}}</div>”该问题<em>{{confirm.state==2?'取消':''}}置顶</em>操作吗？</div>
				<div class="confirm-txt df wao" v-if="confirm.type=='topAns'">确认对该回答<em>{{confirm.state==2?'取消':''}}置顶</em>操作吗？</div>
				<div class="confirm-txt df wao" v-else-if="confirm.type=='prize'">确认对“<div class="ov-d" :class="{ flex: confirm.txt.length>6}">{{confirm.txt}}</div>”该问题<em>{{confirm.state==2?'取消':''}}加精</em>操作吗？</div>
				<div class="confirm-txt df wao" v-else-if="confirm.type=='remove'">确认对“<div class="ov-d" :class="{ flex: confirm.txt.length>6}">{{confirm.txt}}</div>”该问题<em>删除</em>操作吗？</div>
				<div class="confirm-txt df wao" v-else-if="confirm.type=='archive'">确认将该回答进行<em>归档</em>操作吗？</div>
				<div class="confirm-txt df wao" v-else-if="confirm.type=='removeAns'">确认<em>删除</em>该回答吗？</div>
				<div class="confirm-end df war hao">
					<div class="confirm-btn" @click="resConfirm" v-if="confirm.type=='top'">{{confirm.state==2?'取消':'确定'}}置顶</div>
					<div class="confirm-btn" @click="resConfirm" v-if="confirm.type=='topAns'">{{confirm.state==2?'取消':'确定'}}置顶</div>
					<div class="confirm-btn" @click="resConfirm" v-else-if="confirm.type=='prize'">{{confirm.state==2?'取消':'确定'}}加精</div>
					<div class="confirm-btn" @click="resConfirm" v-else-if="confirm.type=='remove'">确定删除</div>
					<div class="confirm-btn" @click="resConfirm" v-else-if="confirm.type=='archive'">确定归档</div>
					<div class="confirm-btn" @click="resConfirm" v-else-if="confirm.type=='removeAns'">确定删除</div>
					<div class="confirm-btn" @click="closeConfirm">取消</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import h5Api from '../../../script/api.js'
	import h5ApiFile from '../../../script/apiFile.js'
	import h5PublicApi from '../../../script/public.js'

	let collect_obj = null;

	export default {
		name: 'model_detail_page',
		data () {
			return {
				pageType: 'default', // 页面类型 [default 普通详情] [adminManager 管理详情]
				mid: '',
				pagenum: 1,
				pagesize: 10,
				state: false,
				isRule: false, // 是否为公告
				type: [], // [top 置顶] [prize 加精]
				catId: '',
				catTitle: '',
				title: '',
				txt: '',
				status: 0, // 状态 [0 审核中] [1 审核通过] [2 审核驳回] [255 已删除]
				likeCount: 0,
				answerCount: 0,
				account: '',
				user: '',
				userId: 0,
				date: '',
				list: [],
				isLike: false,
				likeId: null,
				isFollow: false,
				followId: null,
				files: [],
				relation: {
					id: '',
					title: '',
				},
				collectBase: {
					id: '',
					index: null,
					has: false,
					choose: [],
					list: [],
				},
				collectAddBase: {
					has: false,
					val: '',
				},
				confirm: {
					id: '',
					has: false,
					state: 1,
					type: '',
					txt: '',
				},

				isMode: false,
			}
		},
		watch: {
			'$route'(to,from){
				this.reloadPage();
			}
		},
		mounted(){
			this.reloadPage();
		},
		methods: {
			getModerator(id){ // 获取版主
				this.h5Ajax("get", `$/category/selectModerator/${id}`, false).then( res => {
					if(res){
						let userId = sessionStorage.getItem('userId');
						if(this.$h5Power == 'admin' || this.$h5Power == 'instructor' || this.$h5Power == 'teacher'
						|| userId == res.moderatorUserId || userId == res.deputyModeratorUserId){
							this.isMode = true
						}else{
							this.isMode = false
						}
						// console.log(this.isMode)
					}
				})
			},
			setBestAnswer(id){ //设置最佳答案
				this.h5Ajax("post", "$/answers/setBestAnswer", {
					id,
				}, true).then( result => {
					if(result === true){
						// console.log(this.list)
						this.list.map( v => {
							if(v.id === id){
								v.bestFlag = 1
							}else{
								v.bestFlag = 0
							}
						})
					}
				})
			},
			initData(){
				this.pageType = 'default'; // 页面类型 [default 普通详情] [adminManager 管理详情]
				this.mid = '';
				this.pagenum = 1;
				this.pagesize = 10;
				this.state = false;
				this.isRule = false; // 是否为公告
				this.type = []; // [top 置顶] [prize 加精]
				this.catId = '';
				this.catTitle = '';
				this.title = '';
				this.txt = '';
				this.status = 0; // 状态 [0 审核中] [1 审核通过] [2 审核驳回] [255 已删除]
				this.likeCount = 0;
				this.answerCount = 0;
				this.account = '';
				this.user = '';
				this.userId = 0;
				this.date = '';
				this.list = [];
				this.isLike = false;
				this.likeId = null;
				this.isFollow = false;
				this.followId = null;
				this.relation = {
					id: '',
					title: '',
				};
				this.collectBase = {
					id: '',
					index: null,
					has: false,
					choose: [],
					list: [],
				};
				this.collectAddBase = {
					has: false,
					val: '',
				};
				this.confirm = {
					id: '',
					has: false,
					state: 1,
					type: '',
					txt: '',
				};
			},
			reloadPage(){
				this.initData();

				this.mid = this.$route.query.id;
				this.pageType = this.$route.query.type||'default';
				this.getDetail();

				if (!this.mid) {
					return ;
				}

				// 写入浏览记录
				this.h5Ajax('post','$/browses/add',{
					browsesId: this.mid,
					types: 1,
				}).then(r=>{}).catch(err => {
					console.error('err:' + err)
				})
			},
			dateTime(timestamp){
				if(!timestamp){ return ''; }
				var date = new Date(timestamp);
				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			downloadFile(data){
				h5ShowLoad();
				this.h5Ajax('post','$/downloads/add',{
					downloadId: data.id,
					types: 1,
				},true).then(r=>{
					let fileCheckClock = setInterval(r2=>{
						this.h5Ajax('get','$/downloads/findById/'+r,{},true).then(r3=>{
							if(r3.status>=3){
								clearInterval(fileCheckClock);
								window.location.href = h5Api+'downloads/'+r;
								h5CloseLoad();
							}
						})
					},1000)
				})
			},
			listenScroll(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData();
				}
			},
			addMoreData() { //加载更多
				if(this.state){
					return false;
				}
				this.pagenum ++;
				this.getDetail();
			},
			reloadDetail(){
				this.list = [];
				this.pagenum = 1;
				this.state = false;
				this.getDetail();
			},
			getDetail(){
				this.state = true;

				this.h5Ajax('get','$/questions/detail',{
					id: this.mid,
					page: this.pagenum,
					size: this.pagesize,
				}).then(r=>{
					if (r == null) {
                        alert('此条提问已被删除');
                        setTimeout(() => {
                            h5PublicApi.jumpRecard(true);
                        }, 1000);
                        return;
                    }

					this.isRule = (r.announcement==1);
					this.type = []; // [top 置顶] [prize 加精]
					if(r.top==1){
						this.type.push('top');
					}
					if(r.refining==1){
						this.type.push('prize');
					}
					this.getModerator(r.categoryId)
					this.catId = r.categoryId;
					this.catTitle = r.categoryName;
					this.title = r.title;
					this.txt = r.content.replace(/\r\n/g,"<br>").replace(/\n/g,"<br>");
					this.status = r.status; // 状态 [0 审核中] [1 审核通过] [2 审核驳回] [255 已删除]
					this.likeCount = r.approvalTotal;
					this.answerCount = r.answerTotal;
					this.account = r.creatorMapperNumber;
					this.user = r.creatorName;
					this.userId = r.creatorId;
					this.date = this.dateTime(r.createTime);
					this.isLike = (r.approval>0);
					this.likeId = r.approval;
					this.isFollow = (r.attention>0);
					this.followId = r.attention;
					var files = [];
					(r.attachmentList||[]).forEach((v,i)=>{
						files.push({
							id: v.id,
							name: v.name,
							// url: h5ApiFile+v.url,
						})
					});


					this.files = files;
					this.relation = {
						id: r.relation==0?'':r.relation,
						title: r.relationTitle||'',
					}

					if(r.answers.content.length>0){
						for(var i in r.answers.content){
							var d = r.answers.content[i];
							var files_item = [];
							(d.attachmentList||[]).forEach((v,i)=>{
								files_item.push({
									id: v.id,
									name: v.name,
									// url: h5ApiFile+v.url,
								})
							})
							d.files = files_item;
							d.content = d.content.replace(/<img /g,'<img preview="1" ')
							this.list.push(d)
						}

						this.state = false;

						setTimeout(this.$previewRefresh,500);
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			follow(){
				if(this.status==0){
					alert('问题还在审核中，不可操作');
					return;
				}else if(this.status==2){
					alert('问题被驳回，不可操作');
					return;
				}else if(this.status==255){
					alert('问题被删除，不可操作');
					return;
				}

				if(this.isFollow){
					this.h5Ajax('post','$/attentions/cancel',{
						id: this.followId,
					}).then(r=>{
						// this.reloadDetail();
						this.isFollow = false;
						this.followId = 0;
					})
				}else{
					this.h5Ajax('post','$/attentions/add',{
						attentionId: this.mid,
						types: 1,
					}).then(r=>{
						// this.reloadDetail();
						this.isFollow = true;
						this.followId = r.id;
					})
				}
			},
			like(){
				if(this.status==0){
					alert('问题还在审核中，不可操作');
					return;
				}else if(this.status==2){
					alert('问题被驳回，不可操作');
					return;
				}else if(this.status==255){
					alert('问题被删除，不可操作');
					return;
				}

				if(this.isLike){
					this.h5Ajax('post','$/approvals/cancel',{
						id: this.likeId,
					}).then(r=>{
						// this.reloadDetail();
						this.isLike = false;
						this.likeId = 0;
						this.likeCount --;
					})
				}else{
					this.h5Ajax('post','$/approvals/add',{
						approvalId: this.mid,
						types: 1,
					}).then(r=>{
						// this.reloadDetail();
						this.isLike = true;
						this.likeId = r.id;
						this.likeCount ++;
					})
				}
			},
			openConfirm(type,txt,state,aid){
				if(type!='remove'){
					if(this.status==0){
						alert('问题还在审核中，不可操作');
						return;
					}else if(this.status==2){
						alert('问题被驳回，不可操作');
						return;
					}else if(this.status==255){
						alert('问题被删除，不可操作');
						return;
					}
				}

				this.confirm = {
					id: (type=='topAns'||type=='removeAns'||type=='archive'?aid:this.mid),
					has: true,
					state: (state?2:1),
					type: type,
					txt: txt,
				};
			},
			closeConfirm(){
				this.confirm.has = false;
			},
			resConfirm(){
				if(this.confirm.id==''){
					return;
				}

				if(this.confirm.type=='top'){ // 置顶问题
					this.h5Ajax('post','$/questions/'+(this.type.indexOf('top')>=0?'unTop':'top'),{
						id: this.confirm.id,
					}).then(r=>{
						this.confirm.has = false;
						this.reloadDetail();
					}).catch(err => {
						console.error('err:' + err)
					})
				}else if(this.confirm.type=='prize'){ // 加精
					this.h5Ajax('post','$/questions/'+(this.type.indexOf('prize')>=0?'unRefining':'refining'),{
						id: this.confirm.id,
					}).then(r=>{
						this.confirm.has = false;
						this.reloadDetail();
					}).catch(err => {
						console.error('err:' + err)
					})
				}else if(this.confirm.type=='remove'){ // 删除问题
					this.h5Ajax('post','$/questions/delete',{
						id: this.confirm.id,
					}).then(r=>{
						// this.$router.go(-1);
						h5PublicApi.jumpRecard(true);
					}).catch(err => {
						console.error('err:' + err)
					})
				}else if(this.confirm.type=='archive'){ // 归档回答
					this.h5Ajax('post','$/answers/archive',{
						id: this.confirm.id,
					}).then(r=>{
						this.confirm.has = false;
						this.reloadDetail();
					}).catch(err => {
						console.error('err:' + err)
					})
				}else if(this.confirm.type=='topAns'){ // 置顶回答
					this.h5Ajax('post','$/answers/'+(this.confirm.state==2?'unTop':'top'),{
						id: this.confirm.id,
					}).then(r=>{
						this.confirm.has = false;
						this.reloadDetail();
					}).catch(err => {
						console.error('err:' + err)
					})
				}else if(this.confirm.type=='removeAns'){ // 删除回答
					this.h5Ajax('post','$/answers/delete',{
						id: this.confirm.id,
					}).then(r=>{
						this.confirm.has = false;
						this.reloadDetail();
					}).catch(err => {
						console.error('err:' + err)
					})
				}
			},
			followItem(id,wid,item){
				if(this.status==0){
					alert('问题还在审核中，不可操作');
					return;
				}else if(this.status==2){
					alert('问题被驳回，不可操作');
					return;
				}else if(this.status==255){
					alert('问题被删除，不可操作');
					return;
				}
				var that = this;
				if(wid>0){
					this.h5Ajax('post','$/attentions/cancel',{
						id: wid,
					}).then(r=>{
						// this.reloadDetail();
						item.attention = 0;
						for(var l in that.list){
							if(that.list[l].creatorId == id) that.list[l].attention = 0;
						}
					})
				}else{
					this.h5Ajax('post','$/attentions/add',{
						attentionId: id,
						types: 3,
					}).then(r=>{
						// this.reloadDetail();
						item.attention = r.id;
						for(var l in that.list){
							if(that.list[l].creatorId == id) that.list[l].attention = r.id;
						}
					})
				}
			},
			collectItem(id,wid,item){
				if(this.status==0){
					alert('问题还在审核中，不可操作');
					return;
				}else if(this.status==2){
					alert('问题被驳回，不可操作');
					return;
				}else if(this.status==255){
					alert('问题被删除，不可操作');
					return;
				}

				if(wid>0){
					this.h5Ajax('post','$/collections/cancel',{
						id: wid,
					}).then(r=>{
						// this.reloadDetail();
						item.collection = 0;
					}).catch(err => {
						console.error('err:' + err)
					})
				}else{
					this.collectBase = {
						id: id,
						index: 1,
						has: true,
						choose: [],
						list: [],
					};
					collect_obj = item;

					this.getCollectList();
				}
			},
			likeItem(id,wid,item){
				if(this.status==0){
					alert('问题还在审核中，不可操作');
					return;
				}else if(this.status==2){
					alert('问题被驳回，不可操作');
					return;
				}else if(this.status==255){
					alert('问题被删除，不可操作');
					return;
				}

				if(wid>0){
					this.h5Ajax('post','$/approvals/cancel',{
						id: wid,
					}).then(r=>{
						// this.reloadDetail();
						item.approval = 0;
						item.approvalTotal --;
					})
				}else{
					this.h5Ajax('post','$/approvals/add',{
						approvalId: id,
						types: 2,
					}).then(r=>{
						// this.reloadDetail();
						item.approval = r.id;
						item.approvalTotal ++;
					})
				}
			},
			aqItem(){
				if(this.status==0){
					alert('问题还在审核中，不可操作');
					return;
				}else if(this.status==2){
					alert('问题被驳回，不可操作');
					return;
				}else if(this.status==255){
					alert('问题被删除，不可操作');
					return;
				}

				h5PublicApi.checkCanHandle(r=>{
					this.$router.replace({ path: '/model/release', query: { id: this.catId, name: this.catTitle, qid: this.mid, type: 'aq' } });
				})
			},
			getCollectList(){
				this.h5Ajax('get','$/favorites/listByUid',{
					personal: 0,
				}).then(r=>{
					this.collectBase.choose = [];
					this.collectBase.list = r;
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			closeCollectBase(){
				this.collectBase.has = false;
			},
			resCollectBase(){
				if(this.collectBase.choose.length==0){
					alert('请选择收藏夹');
					return;
				}

				var fid = this.collectBase.list[this.collectBase.choose].id;

				this.h5Ajax('post','$/collections/add',{
					collectionId: this.collectBase.id,
					favoriteId: fid,
					types: 2,
				}).then(r=>{
					this.collectBase.has = false;
					// this.reloadDetail();
					collect_obj.collection = r.id;
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			showCollectAddBase(){
				this.collectAddBase = {
					has: true,
					val: '',
				}
			},
			closeCollectAddBase(){
				this.collectAddBase.has = false;
			},
			resCollectAddBase(){
				this.h5Ajax('post','$/favorites/add',{
					name: this.collectAddBase.val,
					personal: 0,
				}).then(r=>{
					this.collectAddBase.has = false;
					this.getCollectList();
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			chooseCollectBase(index){
				// if(this.collectBase.choose.indexOf(index)>=0){
				// 	this.collectBase.choose.splice(this.collectBase.choose.indexOf(index),1);
				// }else{
				// 	this.collectBase.choose.push(index);
				// }
				if(this.collectBase.choose[0]==index){
					this.collectBase.choose = [];
				}else{
					this.collectBase.choose = [index];
				}
			},
			checkInput(){
				if(this.collectAddBase.val.length>13){
					this.collectAddBase.val = this.collectAddBase.val.substring(0,13);
				}
			},
			toAnswer(){
				if(this.status==0){
					alert('问题还在审核中，不可操作');
					return;
				}else if(this.status==2){
					alert('问题被驳回，不可操作');
					return;
				}else if(this.status==255){
					alert('问题被删除，不可操作');
					return;
				}

				h5PublicApi.checkCanHandle(r=>{
					this.$router.replace({ path: '/admin/release', query: { cat: this.catTitle, title: this.title, id: this.mid } });
				})
			},
			toEdit(){
				if(this.status==2){
					h5PublicApi.checkCanHandle(r=>{
						this.$router.replace({ path: '/model/release', query: { id: this.catId, name: this.catTitle, qid: this.mid, type: 'edit' } });
					})
				}
			},
			toDetail(data){
				this.$router.replace({ path: '/model/detail', query: { id: data.id } });
			},
			toUser(userId){
				this.$router.replace({ path: '/me/user', query: { id: userId } });
			}
		},
	}
</script>

<style scoped>
	@import './detail';
</style>



// WEBPACK FOOTER //
// src/app/pages/model/detail/detail.vue